/* IMPORT */
import Abstract from './abstract.js';
/* MAIN */
class AbstractHidden extends Abstract {
}
/* EXPORT */
export default AbstractHidden;
